import { useEffect, useRef } from 'react';
import { Button } from '@shared/components';
import { MotorplanPaymentForm } from './MotorplanPaymentForm';
import type { MotorplanPaymentState } from '../hooks/useMotorplanPayment';
import { CHANGE_LINK_LABEL, linkSentNotice } from '../utils/motorplanPaymentCopy';

interface Props {
    motorplan: MotorplanPaymentState;
    formId: string;
    autoFocus: boolean;
    locked: boolean;
}

export function MotorplanPaymentPanel({ motorplan, formId, autoFocus, locked }: Props) {
    const { form, leftToPay, formOpen, openForm } = motorplan;
    const changeButton = useRef<HTMLButtonElement>(null);
    const sentLink = form.sentLink;

    useEffect(() => {
        if (!formOpen && sentLink) changeButton.current?.focus();
    }, [formOpen, sentLink]);

    return (
        <>
            {formOpen ? (
                <MotorplanPaymentForm form={form} id={formId} leftToPay={leftToPay} autoFocusAmount={autoFocus || motorplan.liveLink !== null} />
            ) : (
                <Button ref={changeButton} type="button" variant="secondary" appearance="outline" size="sm" disabled={locked} onClick={openForm}>
                    {CHANGE_LINK_LABEL}
                </Button>
            )}
            {sentLink && (
                <p role="status" className="text-sm text-mp-foreground">
                    {linkSentNotice(sentLink)}
                </p>
            )}
        </>
    );
}
